import { __awaiter, __generator } from "tslib";
/* eslint-disable @typescript-eslint/naming-convention */
import { KnownInstrumentationEvents } from '@office-start/instrumentation-types';
import { getItemRequestData } from './getItemRequestData';
import { postRequest } from './postRequest';
export function pinItem(apiOptions) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, postRequest(apiOptions.pinApiPath, getItemRequestData(apiOptions), KnownInstrumentationEvents.EdgeworthPinItemRequest, "EdgeworthPinItem" /* KnownRequestInstrumentationEvents.EdgeworthPinItemRequest */, apiOptions)];
        });
    });
}
export function unpinItem(apiOptions) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, postRequest(apiOptions.unpinApiPath, getItemRequestData(apiOptions), KnownInstrumentationEvents.EdgeworthUnpinItemRequest, "EdgeworthUnpinItem" /* KnownRequestInstrumentationEvents.EdgeworthUnpinItemRequest */, apiOptions)];
        });
    });
}
//# sourceMappingURL=pinItem.js.map